export default __webpack_public_path__ + "static/media/containerSettings.e07b391c.svg";